import { MAIN_ROUTES } from '@/router/components';
import domains from '@/router/domains';
import { BackgroundColors } from '@/@types/types';
import { UserUiDto } from '@/api';
import collaborationTools from '@/modules/collaboration-tools/routes/collaboration-tools';
import ai from '@/modules/settings/ai/routes/ai';
import support from '@/modules/settings/support/routes/support';
import settingsDrawerItems from '@/modules/settings/navigation/settings-drawer-items';

export default {
  path: '/settings',
  name: 'settings',
  redirect: { name: 'settings.tags' },
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.settings',
    settingsMenu: true,
    navigation: settingsDrawerItems,
  },
  component: MAIN_ROUTES.SETTINGS,
  children: [
    {
      path: 'tags',
      name: 'settings.tags',
      meta: {
        requiresAuth: true,
        breadCrumb: 'app.navigation-drawer.tags',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    domains,
    {
      path: 'notification-rules/add',
      name: 'settings.notification-rules.add',
      meta: {
        requiresAuth: true,
        permissions: ['setting.notification-rule.write'],
        breadCrumb: 'notification_rules.page_name',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'notification-rules/:id',
      name: 'settings.notification-rules.edit',
      meta: {
        requiresAuth: true,
        permissions: ['setting.notification-rule.write'],
        breadCrumb: 'notification_rules.page_name',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'notification-rules',
      name: 'settings.notification-rules',
      meta: {
        requiresAuth: true,
        permissions: ['setting.notification-rule.read'],
        breadCrumb: 'notification_rules.page_name',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'workspaces',
      name: 'settings.workspaces',
      meta: {
        requiresAuth: true,
        roles: [UserUiDto.role.ADMIN],
        breadCrumb: 'app.navigation-drawer.workspaces',
        background: BackgroundColors.SECONDARY,

      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'users',
      name: 'settings.users',
      meta: {
        requiresAuth: true,
        roles: [UserUiDto.role.ADMIN],
        breadCrumb: 'app.navigation-drawer.users',
        background: BackgroundColors.SECONDARY,

      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'teams',
      name: 'settings.teams',
      meta: {
        requiresAuth: true,
        roles: [UserUiDto.role.ADMIN],
        breadCrumb: 'app.navigation-drawer.teams',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'access-tokens',
      name: 'settings.access-tokens',
      meta: {
        requiresAuth: true,
        roles: [UserUiDto.role.ADMIN],
        breadCrumb: 'app.navigation-drawer.access',
        background: BackgroundColors.SECONDARY,

      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'automatic-monitoring',
      name: 'settings.monitors.automatic-monitoring',
      meta: {
        requiresAuth: true,
        roles: [UserUiDto.role.ADMIN],
        breadCrumb: 'app.navigation-drawer.automatic-monitoring',
        background: BackgroundColors.SECONDARY,

      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'custom-metadata',
      name: 'settings.custom-metadata',
      meta: {
        requiresAuth: true,
        roles: [UserUiDto.role.ADMIN],
        breadCrumb: 'app.navigation-drawer.custom_metadata',
        background: BackgroundColors.SECONDARY,

      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'cost',
      name: 'settings.cost',
      meta: {
        requiresAuth: true,
        breadCrumb: 'app.navigation-drawer.cost',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    ai,
    support,
    {
      path: 'integration',
      name: 'settings.integration',
      meta: {
        requiresAuth: true,
        roles: [UserUiDto.role.ADMIN],
        breadCrumb: 'app.navigation-drawer.integration-preference',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'credentials',
      name: 'integrations.credentials',
      props: true,
      meta: {
        requiresAuth: true,
        breadCrumb: 'app.navigation-drawer.credentials',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
      path: 'sso',
      name: 'settings.sso',
      meta: {
        requiresAuth: true,
        roles: [UserUiDto.role.ADMIN],
        breadCrumb: 'app.navigation-drawer.sso',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    collaborationTools,
  ],
};
